import { getWebInstrumentations, initializeFaro } from '@grafana/faro-web-sdk'
import { TracingInstrumentation } from '@grafana/faro-web-tracing'

export default {
  install(Vue, options) {
    const faro = initializeFaro({
      url: FONTAWESOME.GRAFANA_FARO_COLLECTOR_URL,
      app: {
        name: 'fontawesome.com',
        version: FONTAWESOME.APP_VERSION,
        environment: FONTAWESOME.GRAFANA_FARO_COLLECTOR_ENVIRONMENT
      },
      sessionTracking: {
        samplingRate: parseFloat(FONTAWESOME.GRAFANA_FARO_COLLECTOR_SAMPLING_RATE),
        persistent: true
      },
      instrumentations: [
        // Mandatory, omits default instrumentations otherwise.
        ...getWebInstrumentations(),

        // Tracing package to get end-to-end visibility for HTTP requests.
        new TracingInstrumentation()
      ]
    })

    Vue.config.globalProperties.$faro = faro

    // Vue catches errors thrown in templates, lifecycle hooks and handlers and,
    // without a handler, only writes them to the console, so Faro saw them as
    // log lines at best. Report them as errors. Only where Faro is configured:
    // with any handler set Vue stops rethrowing in development, and the Jest
    // suite relies on that rethrow to fail a component that throws on render.
    if (FONTAWESOME.GRAFANA_FARO_COLLECTOR_URL) {
      Vue.config.errorHandler = (error, instance, info) => {
        faro.api.pushError(error instanceof Error ? error : new Error(String(error)), {
          context: { vueInfo: String(info), component: String(instance?.$options?.name || 'anonymous') }
        })
        console.error(error)
      }
    }
  }
}
